import script from "./trademark-registration-process.vue?vue&type=script&setup=true&lang=js"
export * from "./trademark-registration-process.vue?vue&type=script&setup=true&lang=js"

import "@/styles/trademark-registration-process.css?vue&type=style&index=0&id=9fd62b8c&scoped=true&lang=css&external"
import "./trademark-registration-process.vue?vue&type=style&index=1&id=9fd62b8c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fd62b8c"]])

export default __exports__